import UnitsTiles from "../../components/UnitsTiles/UnitsTiles";
import "./FleetDetails.css";

interface FleetDetailsProps {}

const FleetDetails = (props: FleetDetailsProps) => {
  return (
    <section className="fleet-details-container" id="fleetDetails">
      <div className="fleet-details-left-content-container">
        <div className="fleet-details-overview-container">
          <h1 className="fleet-details-h1">Fleet Details</h1>
          <h1 className="fleet-details-overview-h1">Overview</h1>

          <h1 className="fleet-details-first-paragraph">
            At JJJM SUN ENTERPRISES, we take pride in maintaining a diverse and
            well-equipped fleet to meet the varied logistics needs of our
            clients. Here's a detailed overview of our fleet:
          </h1>
          <h1 className="fleet-details-second-paragraph">
            All our vehicles are covered by comprehensive and Inland Marine
            Insurance provided by AXA Philippines Life and General Insurance and
            Mercantile Insurance, ensuring protection and peace of mind for our
            operations and clients. We prioritize regular maintenance and timely
            upgrades to keep our fleet in optimal condition, ensuring
            reliability and efficiency in our services.
          </h1>
        </div>
      </div>
      <div className="fleet-details-right-content-container">
        <div className="fleet-details-units-list-container">
          <UnitsTiles
            label="2 Units Mitsubishi"
            numberOfUnits={2}
            description="Versatile light commercial vehicle known for its reliability and practicality."
          />
          <UnitsTiles
            label="3 Units 4W Truck"
            numberOfUnits={3}
            description="Four-wheeler trucks designed for general transporting of goods and materials."
          />
          <UnitsTiles
            label="8 Units 6W Truck"
            numberOfUnits={8}
            description="Medium to heavy-duty vehicles equipped with three axles for broader capacity."
          />
          <UnitsTiles
            label="2 Units 6WF"
            numberOfUnits={2}
            description="Six-wheeler forward trucks characterized by front-engine, rear-wheel drive design."
          />
          <UnitsTiles
            label="2 Units 10W"
            numberOfUnits={2}
            description="Heavy-duty vehicles with five axles providing stability and substantial payload capacity."
          />
        </div>
      </div>
    </section>
  );
};

export default FleetDetails;